import React from "react";
import { FjdIcon } from "fjd-react-components";

export function RemoveIcon() {
  return <FjdIcon glyph="close" size="s" />;
}
